import { defineFcm } from '../shared/factory';

export const FCM_GOOGLE_PAY_ENABLED = defineFcm('google_pay_enabled').asBoolean().withDefault(false).toConfig();
